import React from 'react';
import { useTranslation } from 'react-i18next';
import './SimplicitySection.css';

const SimplicitySection = () => {
  const { t } = useTranslation();

  return (
    <section className="simplicity-section">
      <div className="simplicity-container">
        {/* Header */}
        <div className="simplicity-header">
          <h2 className="simplicity-title">{t('howItWorks.simplicity.title')}</h2>
          <p className="simplicity-subtitle">{t('howItWorks.simplicity.subtitle')}</p>
        </div>

        {/* Two columns */}
        <div className="simplicity-columns">
          {/* Left: What you do */}
          <div className="simplicity-column you-do">
            <div className="column-header">
              <div className="column-icon">👤</div>
              <h3 className="column-title">{t('howItWorks.simplicity.youDo.title')}</h3>
            </div>

            <div className="column-items">
              <div className="column-item">
                <div className="item-number">1</div>
                <div className="item-content">
                  <div className="item-icon">📝</div>
                  <h4 className="item-title">{t('howItWorks.simplicity.youDo.step1.title')}</h4>
                  <p className="item-description">{t('howItWorks.simplicity.youDo.step1.description')}</p>
                </div>
              </div>

              <div className="column-item">
                <div className="item-number">2</div>
                <div className="item-content">
                  <div className="item-icon">👥</div>
                  <h4 className="item-title">{t('howItWorks.simplicity.youDo.step2.title')}</h4>
                  <p className="item-description">{t('howItWorks.simplicity.youDo.step2.description')}</p>
                </div>
              </div>

              <div className="column-item">
                <div className="item-number">3</div>
                <div className="item-content">
                  <div className="item-icon">🎉</div>
                  <h4 className="item-title">{t('howItWorks.simplicity.youDo.step3.title')}</h4>
                  <p className="item-description">{t('howItWorks.simplicity.youDo.step3.description')}</p>
                </div>
              </div>
            </div>

            <div className="column-time">
              <span className="time-icon">⏱️</span>
              <span className="time-text">{t('howItWorks.simplicity.youDo.time')}</span>
            </div>
          </div>

          {/* Right: What we do automatically */}
          <div className="simplicity-column we-do">
            <div className="column-header">
              <div className="column-icon">🤖</div>
              <h3 className="column-title">{t('howItWorks.simplicity.weDo.title')}</h3>
            </div>

            <div className="column-items">
              <div className="auto-item">
                <div className="auto-icon">📧</div>
                <div className="auto-text">
                  <h4 className="auto-title">{t('howItWorks.simplicity.weDo.item1.title')}</h4>
                  <p className="auto-description">{t('howItWorks.simplicity.weDo.item1.description')}</p>
                </div>
              </div>

              <div className="auto-item">
                <div className="auto-icon">🔔</div>
                <div className="auto-text">
                  <h4 className="auto-title">{t('howItWorks.simplicity.weDo.item2.title')}</h4>
                  <p className="auto-description">{t('howItWorks.simplicity.weDo.item2.description')}</p>
                </div>
              </div>

              <div className="auto-item">
                <div className="auto-icon">📊</div>
                <div className="auto-text">
                  <h4 className="auto-title">{t('howItWorks.simplicity.weDo.item3.title')}</h4>
                  <p className="auto-description">{t('howItWorks.simplicity.weDo.item3.description')}</p>
                </div>
              </div>

              <div className="auto-item">
                <div className="auto-icon">🎯</div>
                <div className="auto-text">
                  <h4 className="auto-title">{t('howItWorks.simplicity.weDo.item4.title')}</h4>
                  <p className="auto-description">{t('howItWorks.simplicity.weDo.item4.description')}</p>
                </div>
              </div>

              <div className="auto-item">
                <div className="auto-icon">🔄</div>
                <div className="auto-text">
                  <h4 className="auto-title">{t('howItWorks.simplicity.weDo.item5.title')}</h4>
                  <p className="auto-description">{t('howItWorks.simplicity.weDo.item5.description')}</p>
                </div>
              </div>
            </div>

            <div className="column-time automatic">
              <span className="time-icon">✨</span>
              <span className="time-text">{t('howItWorks.simplicity.weDo.time')}</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SimplicitySection;
